import { render, staticRenderFns } from "./BaseFrontOfficeCardItem.vue?vue&type=template&id=61dc184a&scoped=true"
import script from "./BaseFrontOfficeCardItem.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeCardItem.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeCardItem.vue?vue&type=style&index=0&id=61dc184a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc184a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
